import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import CustomAppBar from "./CustomAppBar";
import CustomDrawer from "./CustomDrawer";
import {memo} from "react";

const MiniDrawer = ({open, handleDrawerClose, handleDrawerOpen}) => {

    return (
            <CustomDrawer
                open={open}
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
            />
    );
}

export default MiniDrawer